export default "__VITE_ASSET__i82DhsQi__"